import React from 'react';

function InformationSection({
  children,
  title,
  sectionImage,
  orientation,
  url,
}) {
  return (
    <section
      className={`grid lg:container px-6 md:px-10 lg:px-12 xl:px-16 2xl:px-24 mx-auto w-full`}
    >
      {/* Large */}
      <div className='hidden lg:grid'>
        {orientation ? (
          <section className='grid bg-colour4 lg:grid-cols-rev gap-6 w-full pl-12 shadow-cardShadow pr-4'>
            <article className='grid grid-rows-reg gap-6 py-8'>
              <div className='text-center lg:text-left'>
                <h4 className='text-4xl font-titleFont bg-colour5 rounded-md pl-4 mr-10'>
                  {title}
                </h4>
              </div>
              {children}
            </article>
            <div className='grid'>
              <img src={sectionImage} alt='' className='max-h-[400px] my-auto' />
            </div>
          </section>
        ) : (
          <section className='grid lg:grid-cols-reg gap-6 bg-colour5 shadow-cardShadow w-full pr-12 pl-4'>
            <div className='grid'>
              <img src={sectionImage} alt='' className='max-h-[400px] my-auto' />
            </div>
            <article className='grid grid-rows-reg gap-6 py-8'>
              <div className='text-center lg:text-left'>
                <h4 className='text-4xl font-titleFont bg-colour4 rounded-md pl-4 mr-10'>
                  {title}
                </h4>
              </div>
              {children}
            </article>
          </section>
        )}
      </div>

      {/* Phone Screens */}
      <section
        className={`grid px-6 py-2 lg:hidden w-full shadow-cardShadow rounded-md ${
          orientation ? 'bg-colour4' : 'bg-colour5'
        }`}
      >
        <div className='grid'>
          <img src={sectionImage} alt='' className='mx-auto' />
        </div>
        <article className='grid text-center py-6 -mt-4'>
          <div className='text-center lg:text-left py-4'>
            <h4
              className={`text-3xl font-titleFont ${
                orientation ? 'bg-colour5' : 'bg-colour4'
              } rounded-md`}
            >
              {title}
            </h4>
          </div>
          {children}
        </article>
      </section>
    </section>
  );
}

export default InformationSection;
